<template>
    <tr>
        <td class="px-6 py-4 whitespace-nowrap">
            <div class="flex-shrink-0 h-6 w-6 items-center">
                <input
                    type="checkbox"
                    class="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    v-model="user.checked"
                />
            </div>
        </td>
        <td
            class="px-6 py-4 whitespace-nowrap whitespace-pre-line truncate min-w-min"
            style="min-width: 35%; width: 35%"
        >
            <div class="text-sm font-medium text-gray-900">
                {{ user.name }}
            </div>
            <div class="text-sm text-gray-500">
                {{
                    new Intl.NumberFormat("nl-NL", {}).format(
                        user.voting_weight
                    )
                }}
                <span v-if="user.weight_name">
                    {{ t("user." + user.weight_name, user.weight_name) }}
                </span>
                <span v-if="!user.weight_name">
                    {{ t("user.gewicht", "gewicht") }}
                </span>

                <span
                    v-if="user.via_proxy > 0 && user.proxy_weight > 0"
                    class="text-xs"
                >
                    <br />{{ user.via_proxy }}
                    <span v-if="user.via_proxy == 1">
                        {{ t("user.label_volmachten_singular", "volmacht á") }}
                    </span>
                    <span v-if="user.via_proxy > 1">
                        {{ t("user.label_volmachten_plural", "volmachten á") }}
                    </span>

                    {{ user.proxy_weight }}
                    {{ t("user.label_stemgewicht", "stemgewicht") }}
                </span>
            </div>
            <div class="mt-1 flex flex-wrap gap-1">
                <span
                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    v-if="user.is_moderator"
                >
                    {{ t("user.role." + user.role, user.role) }}
                </span>
                <span
                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800"
                    v-if="!user.is_moderator && user.can_publish"
                >
                    {{ t("user.can-publish", "kan uitzenden") }}
                </span>
                <span
                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-indigo-100 text-indigo-800"
                    v-if="!user.is_moderator && !user.can_publish && user.role"
                >
                    {{ t("user.role." + user.role, user.role) }}
                </span>
                <span
                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-indigo-100 text-indigo-800"
                    v-if="!user.is_moderator && !user.can_publish && !user.role"
                >
                    {{ t("user.role.deelnemer", "Deelnemer") }}
                </span>
            </div>
        </td>
        <td class="px-6 py-4 whitespace-pre-line break-all truncate">
            <div class="text-sm text-gray-900">
                {{ user.email }}

                <span
                    v-if="user.status"
                    class="inline-flex items-center px-2 py-0 rounded text-xs font-medium leading-4 bg-red-100 text-red-800"
                    :title="user.bounce_details"
                    >{{ user.status }}</span
                >
            </div>
            <div class="text-sm text-gray-500">
                {{ user.phone }}

                <span
                    v-if="user.phone_check == 'error' && user.phone"
                    class="inline-flex items-center px-2 py-0 rounded text-xs font-medium leading-4 bg-pink-100 text-pink-800"
                    >{{ t("user.incorrect-number", "incorrect nummer") }}</span
                >
                <span
                    v-if="user.phone_check == 'error' && !user.phone"
                    class="inline-flex items-center px-2 py-0 rounded text-xs font-medium leading-4 bg-indigo-100 text-indigo-800"
                    >{{ t("user.missing-number", "nummer mist") }}</span
                >
            </div>
            <div class="text-xs text-gray-400" v-if="user.last_mailed_at" :title="formatMailedDate(user.last_mailed_at)">
                {{ t("user.last-mailed", "Laatst gemaild") }} {{ timeAgo(user.last_mailed_at) }}
            </div>
        </td>
        <td class="px-6 py-4 whitespace-nowrap hidden md:table-cell">
            <div class="flex flex-wrap gap-1" v-if="user.tags && user.tags.length > 0">
                <span
                    v-for="tag in user.tags"
                    :key="tag"
                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-700"
                >
                    {{ tag }}
                </span>
            </div>
        </td>

        <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
            <router-link
                :to="{
                    name: 'attendees-edit',
                    params: {
                        id: user.hash,
                        time: timestamp,
                    },
                }"
                replace
                class="cursor-pointer text-blue-600 hover:text-blue-900"
            >
                <PencilAltIcon
                    class="h-5 w-5 text-blue-600 hover:text-blue-900"
                    aria-hidden="true"
                />
            </router-link>
        </td>
    </tr>
</template>

<script>
import { PencilAltIcon } from "@heroicons/vue/solid";

export default {
    mounted() {
        this.timestamp = new Date().getTime();
        Eventing.listen(
            "formUser",
            () => (this.timestamp = new Date().getTime())
        );
    },
    created() {},
    components: {
        PencilAltIcon,
    },
    props: ["user"],
    data() {
        return {
            timestamp: "ts",
        };
    },
    methods: {
        timeAgo(dateString) {
            const date = new Date(dateString);
            const now = new Date();
            const diffMs = now - date;
            const diffMinutes = Math.floor(diffMs / 60000);
            const diffHours = Math.floor(diffMs / 3600000);
            const diffDays = Math.floor(diffMs / 86400000);

            if (diffMinutes < 1) return "zojuist";
            if (diffMinutes < 60) return diffMinutes + " min geleden";
            if (diffHours < 24) return diffHours + " uur geleden";
            if (diffDays === 1) return "1 dag geleden";
            return diffDays + " dagen geleden";
        },
        formatMailedDate(dateString) {
            const date = new Date(dateString);
            const dd = String(date.getDate()).padStart(2, "0");
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const yy = String(date.getFullYear()).slice(-2);
            const hh = String(date.getHours()).padStart(2, "0");
            const mi = String(date.getMinutes()).padStart(2, "0");
            return `${dd}-${mm}-${yy} ${hh}:${mi}`;
        },
    },
};
</script>
